import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button } from "@/comn/components";
import { lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import { useForm, useFetch, useGrid, useStore, useToast, useAuth, useModal, usePage } from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_ORG_LPCO_RPRT,
    SG_ORG_LPCO_RPRT,
} from "@/tz/go/egaz/osci/ststcl/lpco/service/OsciStstclSelcService";

export const OSCI0502005Q = (props: any) => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0004", "auth_osci0019"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    // 전체 조회용 기관(OGAZ0037)이면 OGA 선택 가능 !== ==!
    const isAllOga = auth.get("orgCd") === "OGAZ0037";

    const [srchPrdDvnCd, setSrchPrdDvnCd] = useState("Y");
    const [orgLpcoRprt, setOrgLpcoRprt] = useState(comnUtils.getGridData([]));
    // ORG LIST
    const [orgCdList, setOrgCdList] = useState([]);
    // ORG LPCO LIST
    const [orgLpcoList, setOrgLpcoList] = useState([]);
    let errmsg: any;

    /*
     * Definition Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Statistics by Search Form !== HSCODE 통계 검색 Form ==!
        orgLpcoRprt: useForm({
            defaultSchema: SF_ORG_LPCO_RPRT,
            defaultValues: {
                ...(pgeStore?.form || {
                    srchPrdDvnCd: srchPrdDvnCd,
                    // 전체 조회용 기관(OGAZ0037)은 OGA를 공백으로 두어 전체 조회 !== ==!
                    orgCd: auth.get("orgCd") === "OGAZ0037" ? "" : auth.get("orgCd"),
                    orgNm: auth.get("orgCd") === "OGAZ0037" ? "" : auth.get("orgNm"),
                }),
            },
        }),
    };

    /*
     * Definition Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        orgLpcoRprt: useGrid({
            defaultSchema: SG_ORG_LPCO_RPRT,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        /* LPCO Component List !== LPCO Component 목록 ==! */
        getOrgLpcoRprt: useFetch({
            api: (page = grid.orgLpcoRprt.page) => {
                return APIS.getOrgLpcoRprt(form.orgLpcoRprt.getValues(), page, grid.orgLpcoRprt.size);
            },
            enabled: comnUtils.isEmpty(form.orgLpcoRprt.errors) && form.orgLpcoRprt.isSubmitted,
            key: [grid.orgLpcoRprt.page, grid.orgLpcoRprt.size],
            onSuccess: (data: any) => {
                setStore(pgeUid, {
                    form: form.orgLpcoRprt.getValues(),
                    page: grid.orgLpcoRprt.page,
                    size: grid.orgLpcoRprt.size,
                });

                setOrgLpcoRprt(data?.orgLpcoRprt || []);
                // if (srchPrdDvnCd == "Y") {
                //     grid.orgLpcoRprt.setShow("column", "ststclYy", true);
                //     grid.orgLpcoRprt.setShow("column", "ststclQrt", false);
                //     grid.orgLpcoRprt.setShow("column", "ststclMm", false);
                // } else if (srchPrdDvnCd == "Q") {
                //     grid.orgLpcoRprt.setShow("column", "ststclYy", true);
                //     grid.orgLpcoRprt.setShow("column", "ststclQrt", true);
                //     grid.orgLpcoRprt.setShow("column", "ststclMm", false);
                // } else if (srchPrdDvnCd == "M") {
                //     grid.orgLpcoRprt.setShow("column", "ststclYy", true);
                //     grid.orgLpcoRprt.setShow("column", "ststclQrt", false);
                //     grid.orgLpcoRprt.setShow("column", "ststclMm", true);
                // } else if (srchPrdDvnCd == "C") {
                //     grid.orgLpcoRprt.setShow("column", "ststclYy", false);
                //     grid.orgLpcoRprt.setShow("column", "ststclQrt", false);
                //     grid.orgLpcoRprt.setShow("column", "ststclMm", false);
                // }
            },
            onError: () => {},
            showToast: false,
        }),
        getOrgLpcoList: useFetch({
            api: (data) => {
                return lpcoUtils.getOrgLpcoList(data);
            },
            onSuccess: (data) => {
                console.log("getOrgLpcoList onSuccess ", data);
                setOrgLpcoList(data || []);
            },
            onError: () => {},
            showToast: false,
        }),
    };

    const handler = {
        /* LPCO Component List !== LPCO Component 목록 ==! */
        getOrgLpcoRprt: () => {
            form.orgLpcoRprt.handleSubmit(
                (data) => {
                    // Check before and after the date !== 날짜 앞뒤 체크 ==!
                    let startDt = "";
                    let endDt = "";
                    let focusName = "";
                    if (srchPrdDvnCd == "Y") {
                        startDt = form.orgLpcoRprt.getValue("srchStrYear");
                        // endDt = form.orgLpcoRprt.getValue("srchEndYear");

                        focusName = "srchEndYear";
                    } else if (srchPrdDvnCd == "Q") {
                        startDt = form.orgLpcoRprt.getValue("srchStrQrtYy") + form.orgLpcoRprt.getValue("srchStrQrt");
                        // endDt = form.orgLpcoRprt.getValue("srchEndQrtYy") + form.orgLpcoRprt.getValue("srchEndQrt");

                        focusName = "srchEndQrtYy";
                    } else if (srchPrdDvnCd == "M") {
                        startDt = form.orgLpcoRprt.getValue("srchStrYmYy") + form.orgLpcoRprt.getValue("srchStrYmMm");
                        // endDt = form.orgLpcoRprt.getValue("srchEndYmYy") + form.orgLpcoRprt.getValue("srchEndYmMm");

                        focusName = "srchEndYmYy";
                    } else if (srchPrdDvnCd == "C") {
                        startDt = form.orgLpcoRprt.getValue("srchCustomStrtDt");
                        endDt = form.orgLpcoRprt.getValue("srchCustomEndDt");

                        focusName = "srchCustomEndDt";
                    }
                    if (srchPrdDvnCd == "C" && endDt < startDt) {
                        modal.openModal({
                            content: "msg.osc.00081",
                        });
                        form.orgLpcoRprt.setFocus(focusName);
                        return false;
                    }

                    grid.orgLpcoRprt.setPage(0);
                    fetch.getOrgLpcoRprt.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        refreshOrgCdList: async () => {
            setOrgCdList((await lpcoUtils.getOrgCdList()) || []);
        },
        refreshOrgLpcoList: async (usrOrgCd: any) => {
            if (usrOrgCd) setOrgLpcoList((await lpcoUtils.getOrgLpcoList(usrOrgCd)) || []);
            else setOrgLpcoList([]);
        },
        setInit: async () => {
            // !== 기관 목록 ==!
            handler.refreshOrgCdList();

            // 기관 LPCO SELECT 목록
            await fetch.getOrgLpcoList.fetch(auth.get("orgCd"));
        },
    };

    useEffect(() => {
        lpcoUtils.setSrchFormFromStore(form.orgLpcoRprt, pgeStore);
        setSrchPrdDvnCd(form.orgLpcoRprt.getValue("setSrchPrdDvnCd") || "Y");
        handler.setInit();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.orgLpcoRprt.schema.orgCd}
                                options={orgCdList}
                                edit={isAllOga}
                                onChange={(v: any) => {
                                    handler.refreshOrgLpcoList(v);
                                }}
                            />
                            <Group.Control {...form.orgLpcoRprt.schema.srchAppCdNo} options={orgLpcoList} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.orgLpcoRprt.schema.srchCstmOfceCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.orgLpcoRprt.schema.srchPrdDvnCd}
                                onChange={(v: any) => {
                                    console.log("v ", v);
                                    setSrchPrdDvnCd(v);
                                }}
                            />
                        </Group.Row>
                        {srchPrdDvnCd == "Y" && (
                            <Group.Row>
                                <Group.Control {...form.orgLpcoRprt.schema.srchStrYear} />
                                {/* <Group.Control {...form.orgLpcoRprt.schema.srchEndYear} /> */}
                            </Group.Row>
                        )}
                        {srchPrdDvnCd == "Q" && (
                            <Group.Row>
                                <Group.Label label={"L_QRT"} required={true}></Group.Label>
                                <Group.Col>
                                    <FormControl {...form.orgLpcoRprt.schema.srchStrQrtYy} />
                                    <Group.Any>-</Group.Any>
                                    <FormControl {...form.orgLpcoRprt.schema.srchStrQrt} />
                                </Group.Col>
                                {/* <Group.Label label={"L_END_QRT"} required={true}></Group.Label>
                                <Group.Col>
                                    <FormControl {...form.orgLpcoRprt.schema.srchEndQrtYy} />
                                    <Group.Any>-</Group.Any>
                                    <FormControl {...form.orgLpcoRprt.schema.srchEndQrt} />
                                </Group.Col> */}
                            </Group.Row>
                        )}
                        {srchPrdDvnCd == "M" && (
                            <Group.Row>
                                <Group.Label label={"L_MM"} required={true}></Group.Label>
                                <Group.Col>
                                    <FormControl {...form.orgLpcoRprt.schema.srchStrYmYy} />
                                    <Group.Any>-</Group.Any>
                                    <FormControl {...form.orgLpcoRprt.schema.srchStrYmMm} />
                                </Group.Col>
                                {/* <Group.Label label={"L_END_YM"} required={true}></Group.Label>
                                <Group.Col>
                                    <FormControl {...form.orgLpcoRprt.schema.srchEndYmYy} />
                                    <Group.Any>-</Group.Any>
                                    <FormControl {...form.orgLpcoRprt.schema.srchEndYmMm} />
                                </Group.Col> */}
                            </Group.Row>
                        )}
                        {srchPrdDvnCd == "C" && (
                            <Group.Row>
                                <Group.Control {...form.orgLpcoRprt.schema.srchCustomRnge} />
                            </Group.Row>
                        )}
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    form.orgLpcoRprt.reset();
                                    // 조회 기간 구분은 화면 상태로 하위 입력을 제어하므로 함께 초기화한다.
                                    setSrchPrdDvnCd("Y");
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getOrgLpcoRprt();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="excelDown"
                                onClick={async () => {
                                    const bResult = await form.orgLpcoRprt.validate();
                                    if (bResult) {
                                        // excel download
                                        lpcoUtils.saveExcelDownload(
                                            BASE.api + "/oga-lpco-rprt/excel-down",
                                            form.orgLpcoRprt.getValues(),
                                        );
                                    }
                                }}
                            />
                        </Layout.Left>
                    </Layout>

                    <Group.Section>
                        <Grid {...grid.orgLpcoRprt.grid} data={orgLpcoRprt} />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
